import Base from 'front/components/Base/Base';
import * as _ from 'underscore';

import {VIEWPORT_EVENTS} from '../../../constants/Constants';
import './Intro.less';

const Selectors = {
    el: '.Intro',
    video: 'video',
    sound: '.Intro-videoSound'
};

const BindFunctions = [
    'onClickSound',
    'playVideo'
];

export default class Intro extends Base {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.sound}`]: this.onClickSound
        };
    }

    constructor() {
        super({el: Selectors.el});
        _.bindAll(this, BindFunctions);
        this.video = this.$(Selectors.video);

        // document.addEventListener('DOMContentLoaded', this.playVideo);
    }

    playVideo() {
        this.video[0].play();
    }

    onClickSound(e) {
        const $target = $(e.currentTarget);
        $target.children('span').removeClass('hidden');

        if (this.video[0]?.muted) {
            this.video[0].muted = false;
            $target.children('span').eq(0)
                .addClass('hidden');
        } else {
            this.video[0].muted = true;
            $target.children('span').eq(1)
                .addClass('hidden');
        }
    }
}
